import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import BlogView from "../views/BlogView.vue";
import ArticleView from "../views/ArticleView.vue";
import AssociatesView from "../views/AssociatesView.vue";
import { getArticle } from "../data/articles";
import { isLocale, localeInfo, siteCopy } from "../data/content";
import { applyMetadata } from "../utils/meta";

const legacyArticles = [
  "mantenimientoweb",
  "presencia-online",
  "optimizacion-posicionamiento",
  "sitioweb-profesional",
  "webprogramada-vs-constructores",
  "seo",
];

const routes = [
  { path: "/", redirect: "/es" },
  {
    path: "/:locale(es|en|it)",
    name: "home",
    component: HomeView,
    props: true,
  },
  {
    path: "/:locale(es|en|it)/associates",
    name: "associates",
    component: AssociatesView,
    props: true,
  },
  {
    path: "/:locale(es|en|it)/blog",
    name: "blog",
    component: BlogView,
    props: true,
  },
  {
    path: "/:locale(es|en|it)/blog/:slug",
    name: "article",
    component: ArticleView,
    props: true,
    beforeEnter: (to) => (getArticle(to.params.slug) ? true : `/${to.params.locale}/blog`),
  },
  { path: "/associates", redirect: "/es/associates" },
  { path: "/blog", redirect: "/es/blog" },
  ...legacyArticles.map((slug) => ({
    path: `/blog/${slug}`,
    redirect: `/es/blog/${slug}`,
  })),
  { path: "/:pathMatch(.*)*", redirect: "/es" },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return new Promise((resolve) => {
        window.setTimeout(() => resolve({ el: to.hash, behavior: "smooth", top: 96 }), 80);
      });
    }
    return savedPosition || { top: 0 };
  },
});

router.afterEach((to) => {
  const locale = isLocale(to.params.locale) ? to.params.locale : "es";
  const htmlLocale = localeInfo[locale].htmlLang;
  const canonical = `https://corpresi.com${to.path}`;

  if (to.name === "article") {
    const article = getArticle(to.params.slug);
    const content = article?.content[locale];
    if (article && content) {
      applyMetadata({
        title: `${content.title} · Resi Corporation`,
        description: content.summary,
        canonical,
        locale: htmlLocale,
        image: article.image,
      });
      return;
    }
  }

  const copy = siteCopy[locale];
  const page =
    to.name === "blog"
      ? copy.blog
      : to.name === "associates"
        ? copy.associated
        : copy.metadata;

  applyMetadata({
    title: page.title.includes("Resi Corporation") ? page.title : `${page.title} · Resi Corporation`,
    description: page.description,
    canonical,
    locale: htmlLocale,
  });
});

export default router;
